import React from 'react';

const TimeRangeSelector = ({ activeRange, onRangeChange }) => {
  const ranges = [
    { id: 'daily', label: 'Daily' },
    { id: 'weekly', label: 'Weekly' },
    { id: 'monthly', label: 'Monthly' },
    { id: 'yearly', label: 'Yearly' }
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {ranges?.map((range) => (
        <button
          key={range?.id}
          onClick={() => onRangeChange(range?.id)}
          className={`px-4 py-2 rounded-lg font-interface text-sm font-medium transition-all duration-250 ${
            activeRange === range?.id
              ? 'bg-primary text-primary-foreground'
              : 'bg-card text-foreground hover:bg-muted'
          }`}
        >
          {range?.label}
        </button>
      ))}
    </div>
  );
};

export default TimeRangeSelector;